import React, {useState} from 'react'
import {
    CarouselProvider,
    Slider,
    Slide,
    ButtonBack,
    ButtonNext,
    DotGroup
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

const GeneratedCarousel = ({outfits,userId}) => {
    const [current, setCurrent] = useState(0)
    const length = outfits.length
    //console.log("the length is for the generation", outfits)
    const prevSlide = () => {
        console.log("SLIDE BACK")
    }

    const nextSlide = () => {
        console.log("SLIDE forward")
    }

    if(!Array.isArray(outfits) || outfits.length <=0) {
        return null;
    }


    return (
        <>
            <CarouselProvider
                    visibleSlides={1}
                    totalSlides={outfits.length}
                    step={1}
                    naturalSlideWidth={10}
                    naturalSlideHeight={10}
                    dragEnabled={false} 
                    touchEnabled={false}
                    className="relative"
                    infinite={true}
                >
                    <div className={"relative mx-auto rounded-xl h-44 lg:h-52 xl:h-80 bg-transparent"}>
                        <Slider className={"h-full w-full bg-transparent"}>
                            {outfits.map((item,index) => {
                                return (
                                    <Slide key={index} index={index} >
                                        <div className="flex flex-row justify-center items-center rounded-xl">
                                            <img className="relative rounded-lg h-44 lg:h-52 xl:h-80 w-4/6 sm:w-64 xl:w-82 object-cover " src={`https://polar-castle-07148.herokuapp.com/api/user/images/wardrobe/${userId}/${item.itemUrl}`}/>
                                            <div className="p-4 bg-transparent rounded-xl w-32 flex-col justify-center ">
                                                <p className="font-bold">{item.brand}</p>
                                                <p>{item.occasion}</p>
                                                <p>{item.style}</p>
                                            </div>
                                        </div>
                                    </Slide>
                                )
                            })}
                        </Slider>
                        {/* <ButtonBack className={"absolute top-2/4 left-0 text-blue-600"}>Back</ButtonBack>
                        <ButtonNext className={"s.buttonNext"}>Next</ButtonNext> */}
                    <ButtonBack>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 xl:h-14 xl:w-14" fill="#000000" viewBox="0 0 24 24" stroke="#ffffff">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
                        </svg>
                    </ButtonBack>
                    <ButtonNext>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 xl:h-14 xl:w-14" fill="#000000"viewBox="0 0 24 24" stroke="#ffffff">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                    </ButtonNext>
                    </div>
                </CarouselProvider>
        </>
        // <section className="flex items-center justify-center relative">    
        //     {outfits.map((item, index) => {
        //         return (
        //             <div className="bg-white rounded-xl h-52 flex flex-row bg-opacity-30 relative">
        //                 <img className="relative rounded-lg flex h-52 w-72 object-cover " src={item.itemUrl}/>
        //                 <div className="m-2 bg-transparent rounded-xl w-max flex-col justify-center items-center">
        //                     <p>BRAND</p>
        //                 </div>
        //                 <div className= "absolute top-1/2 z-50" onClick={prevSlide}>
        //                     <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 outline-none cursor-pointer top-1/2" fill="#00000" viewBox="0 0 24 24" stroke="currentColor" >
        //                         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
        //                     </svg>
        //                 </div>
        //                 <div className= "absolute top-1/2 z-50 right-20" onClick={prevSlide}>
        //                     <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 cursor-pointer" fill="#00000" viewBox="0 0 24 24" stroke="currentColor" onClick={nextSlide}>
        //                         <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        //                     </svg>
        //                 </div>
                       
        //             </div>
        //         )
        //     })}
            
           
        // </section>
        
    )
}

export default GeneratedCarousel